if (!customElements.get('losers-buy-now')) {
  customElements.define(
    'losers-buy-now',
    class LosersBuyNow extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      async onClick() {
        const form = this.closest('form');
        const productForm = this.closest('product-form');
        const addButton = form.querySelector('[name="add"]');
        if (addButton?.disabled || this.button.getAttribute('aria-busy') === 'true') return;

        this.button.setAttribute('aria-busy', 'true');
        productForm?.handleErrorMessage();

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          const data = await response.json();

          if (!response.ok) {
            productForm?.handleErrorMessage(data.description || data.message);
            this.button.removeAttribute('aria-busy');
            return;
          }

          window.location.href = '/checkout';
        } catch (e) {
          console.error(e);
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
